import axios from 'axios'

export async function createSimCard(payload) {
    return axios
        .post(`${process.env.API_URL}/sim-management`, payload)
        .then(response => response.data)
}
